import React, { useCallback, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";

import Selector from "../../../components/selector";
import { RESTRICTION_TYPE } from "../../witadmin/Common/constants";
import { StyledGrid, StyledRow, StyledCol } from "../styled";
import { getValuesByNumber } from "../utils";

import { es, enUS } from "date-fns/locale";
import { differenceInDays, format, setDay } from "date-fns";

const messages = defineMessages({
  nigth: {
    id: "quotation.nigth",
    defaultMessage: "noche",
  },
  soldOut: {
    id: "quotation.restriction.soldOut",
    defaultMessage: "AGOTADA",
  },
  days: {
    id: "quotation.restriction.days",
    defaultMessage: "días",
  },
  hours: {
    id: "quotation.restriction.hours",
    defaultMessage: "horas",
  },
  nigths: {
    id: "quotation.restriction.nigths",
    defaultMessage: "noches",
  },
  room: {
    id: "quotation.cardInventory.room",
    defaultMessage: "Habitación",
  },
  minStay: {
    id: "quotation.restriction.minStay",
    description: "Stay Restriction message on inventory",
    defaultMessage: "Min. Stay",
  },
  maxStay: {
    id: "quotation.restriction.maxStay",
    description: "Stay Restriction message on inventory",
    defaultMessage: "Max. Stay",
  },
  minNotice: {
    id: "quotation.restriction.minNotice",
    description: "Notice Restriction message on inventory",
    defaultMessage: "Min. Advance",
  },
  maxNotice: {
    id: "quotation.restriction.maxNotice",
    description: "Notice Restriction message on inventory",
    defaultMessage: "Max. Advance",
  },
  restrictedCheckIn: {
    id: "quotation.restriction.checkIn",
    description: "CHECK-IN",
    defaultMessage: "CHECK-IN",
  },
  restrictedCheckOut: {
    id: "quotation.restriction.checkOut",
    description: "CHECK-OUT",
    defaultMessage: "CHECK-OUT",
  },
});

const getCheckedMealplan = (mealplan: any, actRoom: any, defMealPlan: any) => {
  if (actRoom?.mealplan) {
    return mealplan?.value === actRoom?.mealplan;
  } else {
    return defMealPlan === mealplan;
  }
};

const objDay: any = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const translateDayOfWeek = (checkInDays: string[], lang: string) => {
  const arrDays: string[] = [];
  checkInDays.forEach(day => {
    arrDays.push(
      format(setDay(new Date(), objDay[day]), "EEEEEE", {
        locale: lang === "es-ES" ? es : enUS,
      }).toLocaleUpperCase()
    );
  });
  return arrDays.join(",");
};

const getLabelButtonStatus = (valuesPrices: any, intl: any) => {
  let label = "SELECCIONAR";
  let labelRestricted = "";

  if (valuesPrices.restricted) {
    switch (valuesPrices?.lastStatus?.filterType) {
      case RESTRICTION_TYPE.CHECK_IN_CHECK_OUT:
        const days =
          valuesPrices?.lastStatus?.value?.checkInDays ||
          valuesPrices?.lastStatus?.value?.checkOutDays;
        const label = valuesPrices?.lastStatus?.value?.checkInDays
          ? intl.formatMessage(messages.restrictedCheckIn)
          : intl.formatMessage(messages.restrictedCheckOut);
        labelRestricted = `${label} ${translateDayOfWeek(days, intl.locale)}`;
        break;

      case RESTRICTION_TYPE.MIN_STAY:
        labelRestricted = `${intl.formatMessage(messages.minStay)} ${
          valuesPrices.lastStatus.value
        } ${intl.formatMessage(messages.days)}`;
        break;

      case RESTRICTION_TYPE.MAX_STAY:
        labelRestricted = `${intl.formatMessage(messages.maxStay)} ${
          valuesPrices.lastStatus.value
        } ${intl.formatMessage(messages.days)}`;
        break;

      case RESTRICTION_TYPE.MIN_NOTICE:
        let newValue;
        let txt = intl.formatMessage(messages.hours);
        const auxRes = valuesPrices.lastStatus.value % 24 === 0;
        if (auxRes) {
          newValue = valuesPrices.lastStatus.value / 24;
          txt = intl.formatMessage(messages.days);
        } else {
          newValue = valuesPrices.lastStatus.value;
        }
        labelRestricted = `${intl.formatMessage(messages.minNotice)} ${newValue} ${txt}`;
        break;

      case RESTRICTION_TYPE.MAX_NOTICE:
        let newValueMax;
        let txtMax = intl.formatMessage(messages.hours);
        const auxResMax = valuesPrices.lastStatus.value % 24 === 0;
        if (auxResMax) {
          newValueMax = valuesPrices.lastStatus.value / 24;
          txtMax = intl.formatMessage(messages.days);
        } else {
          newValueMax = valuesPrices.lastStatus.value;
        }
        labelRestricted = `${intl.formatMessage(messages.maxNotice)} ${newValueMax} ${txtMax}`;
        break;

      default:
        break;
    }
    label = `${labelRestricted}`;
  } else if (valuesPrices.availability <= 0) {
    label = intl.formatMessage(messages.soldOut);
  }
  return label;
};

const getColorButtonStatus = (valuesPrices: any) => {
  let label = "";
  if (valuesPrices.restricted) {
    label = "#B3B3B3";
  } else if (valuesPrices.availability <= 0) {
    label = "#656565";
  }
  return label;
};

const getStyleOfButton = (valuesPrices: any) => {
  const color = getColorButtonStatus(valuesPrices);
  if (color === "primary") {
    return {};
  } else {
    return {
      backgroundColor: color,
      borderColor: color,
    };
  }
};

const priceOfInventory = ({ inventory, ratioCurrency, addObligatoryExtras }: any) => {
  return (
    (inventory?.mealPlan?.prices?.totalRate +
      (addObligatoryExtras
        ? (inventory?.mealPlan?.prices?.obligatoryExtrasValue || 0) / (inventory?.rooms?.value || 1)
        : 0)) *
    ratioCurrency
  );
};

export const CardInventory = ({
  inventory,
  ratioCurrency,
  tab,
  changeMealPlanInventory,
  changeRoomInventory,
  handleSelectRoom,
  indexInventory,
  actualRoom,
  setOccupations,
}: any) => {
  const [diffDate, setDiffDate] = useState(0);
  const [valuesRoomAccommodation, setValuesRoomAccommodation] = useState();

  useEffect(() => {
    setValuesRoomAccommodation(tab?.accommodations?.[actualRoom]);
  }, [actualRoom, tab]);

  useEffect(() => {
    const startReservation = new Date(tab.checkIn);
    const endReservation = new Date(tab.checkOut);
    setDiffDate(differenceInDays(endReservation, startReservation));
  }, [tab]);

  const handleSelect = useCallback(() => {
    handleSelectRoom(inventory);
    setOccupations(inventory.mealPlan.occupations);
  }, [inventory]);

  const intl = useIntl();

  return (
    <div style={{ border: "1px #656565 solid", borderRadius: "4px", marginTop: "20px" }}>
      <StyledGrid padding={"20px"}>
        <StyledRow>
          <StyledCol xs={9}>
            <div style={{ fontSize: "18px", fontWeight: 600, color: "#656565" }}>
              {inventory.nameAccommodation}
            </div>
          </StyledCol>
          <StyledCol xs={3}>
            <StyledGrid>
              <StyledRow>
                <StyledCol
                  xs={12}
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    visibility: `${
                      inventory.mealPlan.prices.availability <= 0 ? "hidden" : "visible"
                    }`,
                  }}>
                  <div
                    style={{
                      color: "#656565",
                      fontSize: "12px",
                      textDecoration: "line-through",
                    }}>
                    {(inventory?.mealPlan?.prices?.originalRate * ratioCurrency).toFixed(2)}
                  </div>
                </StyledCol>
                <StyledCol
                  xs={12}
                  style={{
                    justifyContent: "flex-end",
                    visibility: `${
                      inventory.mealPlan.prices.availability <= 0 ? "hidden" : "visible"
                    }`,
                  }}>
                  <div style={{ color: "#656565", fontSize: "23px", fontWeight: 600 }}>
                    {priceOfInventory({
                      inventory,
                      ratioCurrency,
                      addObligatoryExtras:
                        tab?.configurations?.addObligatoryExtrasRateToRoomSelection,
                    }).toFixed(2)}
                  </div>
                </StyledCol>
              </StyledRow>
            </StyledGrid>
          </StyledCol>
        </StyledRow>

        <StyledRow>
          <StyledCol xs={9}>
            <div style={{ color: "#FF6136", fontWeight: 600, fontSize: "15px" }}>
              {inventory.nameCondition}
            </div>
          </StyledCol>
          <StyledCol xs={3}>
            <StyledGrid>
              <StyledRow>
                <StyledCol
                  xs={12}
                  style={{
                    justifyContent: "flex-end",
                    visibility: `${
                      inventory?.mealPlan?.prices?.availability <= 0 ? "hidden" : "visible"
                    }`,
                  }}>
                  <div style={{ color: "#656565", fontSize: "11px" }}>
                    {`${tab?.currency?.value} total`}
                  </div>
                </StyledCol>
              </StyledRow>
            </StyledGrid>
          </StyledCol>
        </StyledRow>

        <StyledRow paddingTop={"0px"}>
          <StyledCol xs={9} style={{ paddingTop: "20px" }}>
            <Form>
              <div className="mb-3">
                {inventory.mealplans.map((mealPlan: any, index: number) => {
                  const name = mealPlan?.prices?.name;
                  return (
                    <Form.Check type={"radio"} id={`check-api-radio`}>
                      <Form.Check.Input
                        onClick={() => {
                          changeMealPlanInventory(indexInventory, mealPlan);
                        }}
                        defaultChecked={getCheckedMealplan(
                          mealPlan,
                          valuesRoomAccommodation,
                          inventory.mealplans[0]
                        )}
                        name={"radioMealPlan"}
                        type={"radio"}
                      />
                      <Form.Check.Label>{`${mealPlan.label}${name ? " | " : ""}${
                        name ? name.substring(0, name.indexOf(",")) : ""
                      }`}</Form.Check.Label>
                    </Form.Check>
                  );
                })}
              </div>
            </Form>
          </StyledCol>
          <StyledCol
            xs={3}
            style={{
              alignItems: "flex-start",
              justifyContent: "flex-end",
              visibility: `${inventory.mealPlan.prices.availability <= 0 ? "hidden" : "visible"}`,
            }}>
            <div style={{ color: "#656565" }}>
              {`${(priceOfInventory({ inventory, ratioCurrency }) / diffDate).toFixed(2)} ${
                tab?.currency?.value
              } / ${intl.formatMessage(messages.nigth)}`}
            </div>
          </StyledCol>
        </StyledRow>

        <StyledRow paddingTop={"16px"}>
          <StyledCol xs={9}>
            <div style={{ width: "30%", background: "red !important" }}>
              {inventory.mealPlan.prices.availability > 0 && (
                <Selector
                  options={getValuesByNumber(
                    inventory.mealPlan.prices.availability,
                    intl.formatMessage(messages.room),
                    1
                  )}
                  value={inventory.rooms}
                  onChange={(selectedOption: any) => changeRoomInventory(inventory, selectedOption)}
                />
              )}
            </div>
          </StyledCol>

          <StyledCol xs={3} style={{ justifyContent: "flex-end" }}>
            <Button
              style={getStyleOfButton(inventory.mealPlan.prices)}
              disabled={inventory.mealPlan.prices.availability <= 0}
              onClick={handleSelect}>
              <div style={{ fontWeight: 600 }}>
                {`${getLabelButtonStatus(inventory.mealPlan.prices, intl)}`}
              </div>
            </Button>
          </StyledCol>
        </StyledRow>
      </StyledGrid>
    </div>
  );
};
